import { isEqual } from 'lodash'

/**
 * @param {Object} newValue
 * @param {Object} oldValue
 * @returns {Array} [diff, hasChanged]
 * @todo: can be optimized using reference below (in this file)
*/
export const diffObject = (newValue, oldValue) => {
  const keys = new Set([...Object.keys(newValue), ...Object.keys(oldValue)])
  const _newValue = {}

  keys.forEach((key) => {
    // if both value is falsy
    if (!oldValue[key] && !newValue[key]) return

    // if oldValue has same value with newValue
    if (oldValue[key] == newValue[key]) return

    // if the oldValue is 'Invalid date' and newValue is null
    if (oldValue[key] === 'Invalid date' && newValue[key] === null) return

    // if it is array
    if (Array.isArray(oldValue[key]) || Array.isArray(newValue[key])) {
      // if oldValue is undefined but the newValue is empty array
      if (!oldValue[key] && newValue[key].length === 0) return

      // matching oldValue and newValue array
      const sortedNewValue = newValue[key]?.length ? newValue[key].sort() : newValue[key]
      const sortedOldValue = oldValue[key] ? oldValue[key].sort() : oldValue[key]

      const isSameArray = isEqual(sortedNewValue, sortedOldValue)

      if (isSameArray) return
    }

    _newValue[key] = newValue[key]
  })

  const entries = Object.entries(_newValue)
  const hasChanged = entries.length > 0 && entries.every((value) => value)
  return [_newValue, hasChanged]
}

/**
// Reference for refactoring:

import { isEqual, isEqualWith, fromPairs, toPairs, differenceWith } from 'lodash'

export const diffObject = (newValue, oldValue) => {
  const changes = differenceWith(toPairs(newValue), toPairs(oldValue), isEqual)
  const data = fromPairs(changes)
  return {
    data,
    hasChanged: Object.keys(data).length > 0,
  }
}

export function diffObject(obj1, obj2) {
  const diff = {}

  isEqualWith(obj1, obj2, (val1, val2, key) => {
    if (Array.isArray(val1) && Array.isArray(val2)) {
      if (!isEqual(val1.sort(), val2.sort())) {
        diff[key] = [val1, val2]
      }
      return true
    } else if (typeof val1 === 'object' && typeof val2 === 'object') {
      return undefined // Continue with default comparison
    } else {
      if (val1 !== val2) {
        diff[key] = [val1, val2]
      }
      return true
    }
  })

  return diff
}
*/
